import React from "react";
import { Target, Award, Users } from "lucide-react";

// FeaturesSection Component
const FeaturesSection = () => {
  const features = [
    {
      icon: <Target size={48} color="#0891b2" />,
      title: "Precision Drilling",
      description:
        "Expert ball drilling tailored to your unique bowling style, hand measurements, and performance goals. Every hole perfectly positioned for maximum control.",
    },
    {
      icon: <Award size={48} color="#0891b2" />,
      title: "Premium Equipment",
      description:
        "Top-brand bowling balls, shoes, and accessories from industry leaders. Only the finest equipment for serious bowlers who demand excellence.",
    },
    {
      icon: <Users size={48} color="#0891b2" />,
      title: "Expert Service",
      description:
        "Professional advice and maintenance services to keep your equipment in peak condition. Decades of combined experience at your service.",
    },
  ];

  return (
    <section style={{ padding: "4rem 0", backgroundColor: "#f5f5f5" }}>
      <div
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
      >
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#333",
          }}
        >
          Why Choose 900 Pro Shop?
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "2rem",
          }}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              style={{
                textAlign: "center",
                padding: "2.5rem 2rem",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 5px 25px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                borderLeft: "4px solid #0891b2",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 35px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 5px 25px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ marginBottom: "1.5rem" }}>{feature.icon}</div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: "#333",
                }}
              >
                {feature.title}
              </h3>
              <p
                style={{
                  color: "#666",
                  lineHeight: "1.6",
                }}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
